import React, { useContext } from "react";
import { groupContext } from "../index.js";
import OfferPrice from "../offerPrice/offerPrice.js";
import "./style.css";
export default function CategoryPrices(props) {
    const { appearance } = useContext(groupContext);
    if (appearance.priceListType == "in_tab") {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement("div", { className: "category-prices-container" },
        props.offers.length > 0 && (React.createElement("div", { className: "category-prices-title" }, "Cennik:")),
        props.offers
            .filter((offer) => !offer["@hidden"])
            .map((offer, index) => (React.createElement(OfferPrice, { key: index, offer: offer })))));
}
